import { LogErrors } from './../../LogErrors'
import { DoubleAttempt } from './../Helpers/DoubleAttempt'

/**
 * Obtiene el listado de Instructores asociados a un centro.
 */
const GetInstructorsForCenters = async (idCenter, rol, token) => {
    try {
        const parameters = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/GetInstructorsForCenters?IdCenter=${idCenter}&rol=${rol}`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetInstructorsForCenters - DL Instructors', error)
        return { success: false, message: `No ha sido posible obtener el listado de Instructores. Intenta actualizar la página más tarde.` }
    }
}

/**
 * Obtiene los detalles de un instructor (sus grupos).
 */
const GetInstructorDetails = async (idCenter, idInstructor, token) => {
    try {
        const parameters = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/GetInstructorDetails?centerId=${idCenter}&instructorId=${idInstructor}`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetInstructorDetails - DL Instructors', error)
        return { success: false, message: `No ha sido posible obtener los detalles del Instructor.` }
    }
}

/**
 * Genera o consulta el código de acceso/vinculación para Instructores.
 */
const GetInstructorAccessCode = async (idCenter, rol, token) => {
    try {
        const dataToSend = {
            IdCenter: idCenter,
            Rol: rol
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/GetInstructorAccessCode`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetInstructorAccessCode - DL Instructors', error)
        return { success: false, message: `No ha sido posible obtener el código de vinculación.` }
    }
}

/**
 * Resetea la contraseña del Instructor.
 */
const ResetInstructorPassword = async (idCenter, idInstructor, token) => {
    try {
        const dataToSend = {
            CenterId: idCenter,
            UserId: idInstructor
        }
        
        const parameters = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/ResetInstructorPassword`
        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('ResetInstructorPassword - DL Instructors', error)
        return { success: false, message: `No ha sido posible resetear la contraseña del Instructor.` }
    }
}

/**
 * Agrega instructores masivamente mediante un archivo.
 * NOTA IMPORTANTE: Al enviar FormData, no se define el Content-Type para que el navegador asigne el boundary multipart.
 */
const AddInstructorsBulk = async (idCenter, fileObj, token) => {
    try {
        const formData = new FormData()
        formData.append('IdCenter', idCenter)
        formData.append('File', fileObj) // Asegúrate de que el nombre del campo coincida con lo que espera tu Backend

        const parameters = {
            method: 'POST',
            headers: {
                'Authorization': token
                // OJO: No colocar 'Content-Type': 'application/json' aquí.
            },
            body: formData
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/AddInstructorsBulk`
        const response = await fetch(url, parameters) // Usamos fetch directo o adapta DoubleAttempt para no forzar JSON
        const jsonResponse = await response.json()

        if (response.ok && jsonResponse.success) {
            return { success: true, data: jsonResponse.data }
        } else {
            return { success: false, message: jsonResponse.message || 'Error al procesar el archivo.' }
        }
    } catch (error) {
        await LogErrors('AddInstructorsBulk - DL Instructors', error)
        return { success: false, message: `No ha sido posible cargar el archivo de Instructores.` }
    }
}

// =========================================================================
// ENDPOINTS FALTANTES (MOCKS PREPARADOS PARA CUANDO EL BACKEND TE LOS DÉ)
// =========================================================================

const AcceptInstructor = async (idCenter, idInstructor, token) => {
    // URL Ficticia: `${process.env.REACT_APP_API_URL}/api/V5/Leaders/AcceptInstructor`
    return { success: true, message: "Aceptado correctamente (Mock)" }
}

const RejectInstructor = async (idCenter, idInstructor, token) => {
    // URL Ficticia: `${process.env.REACT_APP_API_URL}/api/V5/Leaders/RejectInstructor`
    return { success: true, message: "Rechazado correctamente (Mock)" }
}

const UnlinkInstructor = async (idCenter, idInstructorToRemove, idInstructorToInheritGroups, token) => {
    // URL Ficticia: `${process.env.REACT_APP_API_URL}/api/V5/Leaders/UnlinkInstructor`
    // El payload llevaría ambos IDs en caso de reasignación, o null/0 en idInstructorToInheritGroups si no tenía grupos.
    return { success: true, message: "Desvinculado correctamente (Mock)" }
}

export { GetInstructorsForCenters, GetInstructorDetails, GetInstructorAccessCode, ResetInstructorPassword, AddInstructorsBulk, AcceptInstructor, RejectInstructor, UnlinkInstructor };